import React from 'react';
import { Header, Contacto, Imagen, Footer, AboutMe, Skills} from '../../components/index';
import style from '../HOME/Home.module.css';

const Home = () => {
  return (
    <div className={style.containerHome}>
      <Header />
      <Contacto />
      <Imagen />
      <AboutMe />
      <Skills />
      <Footer />
    </div>
  );
};

export default Home;
